/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Accordion, Button, Col, Container, Form, InputGroup, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import errorHandler from '../../../../support_func/errorHandler';
import unavailable from '../../../../support_func/unavailable';

const GhatorUploadAdmin = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem('autoAcceso');

  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);

  const MAX_UPLOAD = 2000;

  const [serialValidation, setSerialValidation] = useState({
    ok: true,
    error: null, // 'empty' | 'invalid_format' | 'range_inverted' | 'too_many'
    count: 0,
  });

  const [data, setData] = useState({
    idriserial: '',
    v_firmware: '',
    manufacture_date: null,
    manufactured_by: '',
    v_idri: '',
  });

  const [queryType, setQueryType] = useState('serial'); // 'serial' | 'id'
  const [queryValue, setQueryValue] = useState('');
  const [infoResult, setInfoResult] = useState(null);
  const [copiedField, setCopiedField] = useState(null);

  // AJUSTA ESTO a tu ruta real
  const UPLOAD_URL = `${process.env.REACT_APP_API_SRT}/private2/newghatorupload`;
  const INFO_URL = `${process.env.REACT_APP_API_SRT}/private2/ghatorinfo`;

  const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const getFilenameFromDisposition = (disposition) => {
    if (!disposition) return null;
    const match = /filename="?([^"]+)"?/i.exec(disposition);
    return match?.[1] ?? null;
  };

  const isDigits = (s) => /^\d+$/.test(s);

  const validateSerialsLite = (raw) => {
    const s = (raw || '').replace(/\s+/g, '');
    if (!s) return { ok: false, error: 'empty', count: 0 };

    const parts = s.split(',').filter(Boolean);
    if (parts.length === 0) return { ok: false, error: 'empty', count: 0 };

    let count = 0;

    for (const part of parts) {
        const rangeParts = part.split('-');
        if (rangeParts.length > 2) return { ok: false, error: 'invalid_format', count: 0 };

        for (const p of rangeParts) {
        if (!isDigits(p)) return { ok: false, error: 'invalid_format', count: 0 };
        }

        if (rangeParts.length === 1) {
        count += 1;
        } else {
        const start = parseInt(rangeParts[0], 10);
        const end = parseInt(rangeParts[1], 10);
        if (start > end) return { ok: false, error: 'range_inverted', count: 0 };
        count += (end - start + 1);
        }

        if (count > MAX_UPLOAD) {
        return { ok: false, error: 'too_many', count };
        }
    }

    return { ok: true, error: null, count };
  };

  const UploadGhators = async (e) => {
    e.preventDefault();
    setIsPending(true);
    setError(null);

    // backend espera JSON, no multipart
    const payload = {
      idriserial: data.idriserial,
      v_firmware: data.v_firmware,
      manufacture_date: moment(data.manufacture_date).format('DD-MM-YYYY'),
      manufactured_by: data.manufactured_by,
      v_idri: data.v_idri,
    };

    axios
      .post(UPLOAD_URL, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        responseType: 'blob', // <- CLAVE: esperamos CSV
        validateStatus: () => true, // manejamos status nosotros para poder leer blob/JSON
      })
      .then(async (res) => {
        // Si tu backend a veces devuelve JSON (errores), con responseType blob
        // hay que intentar detectar si realmente es JSON.
        const contentType = res.headers?.['content-type'] || '';
        const ok = res.status >= 200 && res.status < 300;

        if (!ok) {
          // Intentar parsear el blob como texto JSON de error
          try {
            const text = await res.data.text();
            const parsed = JSON.parse(text);
            setError(parsed?.message || t('problem'));
          } catch {
            setError(t('problem'));
          }
          setIsPending(false);
          return;
        }

        if (!contentType.includes('text/csv')) {
          // Backend “raro” o caída a HTML/login/etc.
          unavailable(true);
          setIsPending(false);
          return;
        }

        const disposition = res.headers?.['content-disposition'];
        const filename =
          getFilenameFromDisposition(disposition) ||
          `ghator_upload_report_${moment().format('YYYYMMDD_HHmmss')}.csv`;

        downloadBlob(res.data, filename);

        // Limpia formulario (opcional)
        setData({
          idriserial: '',
          v_firmware: '',
          manufacture_date: null,
          manufactured_by: '',
          v_idri: '',
        });

        setIsPending(false);
      })
      .catch((err) => {
        errorHandler(err, setIsPending, setError);
      });
  };

  const fetchGhatorInfo = (e) => {
    e.preventDefault();
    setIsPending(true);
    setError(null);
    setInfoResult(null);

    axios
      .get(INFO_URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          by: queryType,      // 'serial' | 'id'
          value: queryValue,  // string
          // preparado para el futuro:
          fields: ['ncontrol', 'v_firmware', 'v_placa'],
        },
        validateStatus: () => true,
      })
      .then((res) => {
        const ok = res.status >= 200 && res.status < 300;

        if (!ok) {
          setError(res.data?.message || t('problem'));
          setIsPending(false);
          return;
        }

        if (res.data?.status !== 'ok') {
          setError(res.data?.message || t('problem'));
          setIsPending(false);
          return;
        }

        setInfoResult(res.data.data);
        setIsPending(false);
      })
      .catch((err) => {
        errorHandler(err, setIsPending, setError);
      });
  };

  const copyToClipboard = async (text, fieldKey) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(fieldKey);
      setTimeout(() => setCopiedField(null), 1500);
    } catch {
      // silencio: en admin no hace falta ruido
    }
  };

  useEffect(() => {
    error !== null && window.alert(error);
    setError(null);
  }, [error]);

  useEffect(() => {
    setSerialValidation(validateSerialsLite(data.idriserial));
  }, [data.idriserial]);

  return (
    <Container className='text'>
      {isPending && (
        <div className='working_apis'>
          <div className='text-working-apis'>{t('comprobando')}...</div>
        </div>
      )}

      <Accordion defaultActiveKey='0' className='acc' alwaysOpen>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>
            <Table bordered className='mb-0'>
              <thead>
                <tr className='primary text-center dark'>
                  <th className='lh-sm'>
                    <p className='fw-normal lh-sm my-0'>{t('cargaIdris')} (admin)</p>
                  </th>
                </tr>
              </thead>
            </Table>
          </Accordion.Header>

          <Accordion.Body>
            <Form onSubmit={UploadGhators}>
              <Row className='px-0'>
                <Col xs={12} md={6}>
                  <strong>{t('numeroSerie')}/{t('range')}</strong>
                  <InputGroup>
                    <Form.Control
                      required
                      placeholder='e.g.: 100,101,200-250'
                      value={data.idriserial}
                      onChange={(e) => setData({ ...data, idriserial: e.target.value })}
                    />
                  </InputGroup>
                  <div className='mt-2' style={{ fontSize: '0.9em' }}>
                    {!data.idriserial ? (
                        <span style={{ opacity: 0.8 }}>
                        {/* {t('serialFormatHint', { max: MAX_UPLOAD })} */}
                        </span>
                    ) : serialValidation.ok ? (
                        <span style={{ opacity: 0.8 }}>
                        {/* {t('serialCount', { count: serialValidation.count, max: MAX_UPLOAD })} */}
                        </span>
                    ) : (
                        <span style={{ color: '#b00020' }}>
                        {serialValidation.error === 'too_many' && (<>Too many. Max: {MAX_UPLOAD}</>)} {/* not translated on purpose */}
                        {serialValidation.error === 'range_inverted' && `range inverted`} {/* not translated on purpose */}
                        {(serialValidation.error === 'invalid_format' || serialValidation.error === 'empty') &&
                            `invalid format`} {/* not translated on purpose */}
                        </span>
                    )}
                  </div>
                  {/* <div className='mt-1' style={{ fontSize: '0.9em', opacity: 0.8 }}>
                    Acepta comas y rangos con guión
                  </div> */}
                </Col>

                <Col xs={12} md={3}>
                  <strong>{t('firmware')}</strong>
                  <Form.Control
                    required
                    placeholder='e.g.: 3.1.1'
                    type='text'
                    value={data.v_firmware}
                    onChange={(e) => setData({ ...data, v_firmware: e.target.value })}
                  />
                </Col>

                <Col xs={12} md={3}>
                  <strong>{t('vIdri')}</strong>
                  <Form.Control
                    required
                    type='text'
                    placeholder='e.g.: 3.1'
                    value={data.v_idri}
                    onChange={(e) => setData({ ...data, v_idri: e.target.value })}
                  />
                </Col>

                <Col xs={12} md={6} className='mt-2'>
                  <strong>{t('manufacturedBy')}</strong>
                  <Form.Control
                    required
                    type='text'
                    value={data.manufactured_by}
                    onChange={(e) => setData({ ...data, manufactured_by: e.target.value })}
                  />
                </Col>

                <Col xs={12} md={6} className='mt-2'>
                  <strong>{t('manufactureDate')}</strong>
                  <DatePicker
                    required
                    locale={localStorage.getItem('language')}
                    customInput={<Form.Control />}
                    dateFormat='dd-MM-yyyy'
                    selected={data.manufacture_date}
                    onChange={(date) => setData({ ...data, manufacture_date: date })}
                    maxDate={moment()._d}
                    withPortal
                  />
                </Col>

                <Col xs={12} className='mt-3 text-center'>
                  <Button
                    variant='primary'
                    type='submit'
                    disabled={
                      isPending ||
                      !data.idriserial ||
                      !serialValidation.ok ||
                      !data.v_firmware ||
                      !data.v_idri ||
                      !data.manufactured_by ||
                      !data.manufacture_date
                    }
                  >
                    Upload (download CSV)
                  </Button>
                </Col>
              </Row>
            </Form>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey='1'>
          <Accordion.Header>
            <Table bordered className='mb-0'>
              <thead>
                <tr className='primary text-center dark'>
                  <th className='lh-sm'>
                    <p className='fw-normal lh-sm my-0'>{t('info')} #control</p>
                  </th>
                </tr>
              </thead>
            </Table>
          </Accordion.Header>

          <Accordion.Body>
            <Form onSubmit={fetchGhatorInfo}>
              <Row className='px-0'>
                <Col xs={12} md={3}>
                  <strong>{t('buscarpor')}</strong>
                  <Form.Select value={queryType} onChange={(e) => setQueryType(e.target.value)}>
                    <option value='serial'>Serial</option>
                    <option value='id'>ID</option>
                  </Form.Select>
                </Col>

                <Col xs={12} md={6}>
                  <strong>{t('value')}</strong>
                  <Form.Control
                    required
                    type='text'
                    value={queryValue}
                    onChange={(e) => setQueryValue(e.target.value)}
                    placeholder={queryType === 'serial' ? 'e.g.: 12345' : 'e.g.: 987'}
                  />
                </Col>

                <Col xs={12} md={3} className='mt-3 mt-md-0 d-flex align-items-end'>
                  <Button variant='secondary' type='submit' disabled={isPending || !queryValue}>
                    {t('consultar')}
                  </Button>
                </Col>
              </Row>
            </Form>

            {infoResult && (
              <Table bordered hover size='sm' className='mt-3'>
                <tbody>
                  {Object.entries(infoResult).map(([k, v]) => (
                    <tr key={k}>
                      <td style={{ width: '35%' }}>
                        <strong>{k}</strong>
                      </td>
                      <td>
                        {v === null || v === undefined ? (
                          ''
                        ) : k === 'ncontrol' ? (
                          <div className='d-flex align-items-center gap-2'>
                            <span>{String(v)}</span>
                            <Button
                              size='sm'
                              variant='link'
                              className='p-0 text-decoration-none'
                              style={{ lineHeight: 1 }}
                              onMouseDown={(e) => e.preventDefault()}   // evita el estado :active raro en móvil
                              onClick={() => copyToClipboard(String(v), k)}
                              aria-label='Copy to clipboard'
                            >
                              <span style={{ fontSize: '1.1rem' }}>{copiedField === k ? '✔️' : '📋'}</span>
                            </Button>
                          </div>
                        ) : (
                          String(v)
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      
    </Container>
  );
};

export default GhatorUploadAdmin;